// Dashboard and UI Colors
export const UI_COLORS = {
  // Header colors
  headerBackground: '#e2e8f0',
  headerText: '#475569',
  headerStatText: '#059669',
  
  // Background colors
  dashboardBackground: '#f8fafc',
  columnHeaderBackground: '#1e293b',
  statCardBackground: '#f1f5f9',
  
  // Text colors
  textPrimary: '#1f2937',
  textSecondary: '#64748b',
  textMuted: '#6b7280',
  textLight: '#9ca3af',
  headingText: '#334155',
  
  // Border colors
  borderLight: '#e2e8f0',
  borderMedium: '#cbd5e1',
  borderDark: '#e5e7eb',
  borderDashed: '#cbd5e1',
  
  // Card and section colors
  cardBackground: '#f9fafb',
  sectionBackground: '#f3f4f6',
  hoverBackground: '#f1f5f9',
  
  // Status colors
  successLight: '#d1fae5',
  successDark: '#065f46',
  successBorder: '#10b981',
  errorLight: '#fee2e2',
  errorDark: '#991b1b',
  errorBorder: '#ef4444',
  warningLight: '#fef3c7',
  warningDark: '#92400e',
  infoLight: '#dbeafe',
  infoDark: '#1d4ed8',
  primaryLight: '#e0e7ff',
  primaryDark: '#3730a3',
  primaryBorder: '#6366f1',
  
  // Input colors
  inputBorder: '#e2e8f0',
  inputPlaceholder: '#94a3b8',
  
  // Tag colors
  tagBackground: '#e0e7ff',
  tagText: '#4338ca',
  
  // Stat card colors
  statRed: '#ff6b6b',
  statTeal: '#4ecdc4',
  statPurple: '#7c3aed',
  statYellow: '#f59e0b',
  statGreen: '#059669',
  
  // Misc colors
  disabledBackground: '#e2e8f0',
  disabledText: '#94a3b8',
  shadowColor: 'rgba(0, 0, 0, 0.1)',
  heavyShadowColor: 'rgba(0, 0, 0, 0.15)',
  
  // Slider colors
  sliderDotActive: '#cbd5e1',
  sliderDotHover: '#94a3b8',
};

// Re-export existing colors for backward compatibility
export { COLORS } from '../theme/Colors';